import React, { useLayoutEffect, useRef } from "react";
import { FooterByAnima } from "./FooterByAnima";
import image03 from "@/assets/newHome/image-3.png";

const PrivacyPolicy: React.FC = () => {
  const mainRef = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    if (mainRef.current) {
      mainRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <>

    {/* Top Banner with Background Image */}
    <div ref={mainRef} className="relative w-full h-[200px] md:h-[250px] lg:h-[300px] bg-[#F1FDF5] flex items-center justify-start">

        <h1 className="text-4xl md:text-4xl font-bold text-left text-gray-800 z-10 pl-[3rem] md:pl-[7rem] lg:pl-[5rem] xl:pl-[5rem]">Privacy Policy</h1>
        <div className="absolute left-0 bottom-0 w-full opacity-30 z-0">
          <img
            className="w-full object-contain pointer-events-none"
            alt="Construction project showcase"
            src={image03}
          />
        </div>
    </div>



      <div className="min-h-screen  px-6 py-10 md:px-20 lg:px-10">


        <div className="max-w-full mx-auto bg-white p-8 rounded-2xl ">
          {/* <h1 className="text-3xl font-bold text-gray-800 mb-4">Terms & Conditions</h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: April 22, 2025</p> */}

          <div className="space-y-6 text-gray-700 text-base leading-7">
            <section className="space-y-[30px]">
              {/* <h2 className="text-2xl font-semibold mb-2">1. Introduction</h2> */}
              <p className="text-[#0d121f] text-[18px]">
              This privacy notice discloses the privacy practices for BuildMapper Ltd.,
              </p>
              <p className="text-[#0d121f] text-[18px]">
              This privacy notice applies solely to information collected by this website. It will notify you of the following:
              </p>
              <p className="text-[#0d121f] text-[18px]">
                <ol className="space-y-[30px] list-decimal list-inside">
                    <li>What personally identifiable information is collected from you through the website, how it is used and with whom it may be shared.</li>
                    <li>What choices are available to you regarding the use of your data..</li>
                    <li>The security procedures in place to protect the misuse of your information.</li>
                    <li>How you can correct any inaccuracies in the information.</li>
                </ol>
              </p>
            </section>

            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold mb-2 text-primary">
                REGISTRATION
              </h2>
              <p className="text-[#0d121f] text-[18px]">
              In order to use this website, a user must first complete the registration form. During registration a user is required to give certain information (such as name and email address). This information is used to contact you about the products/services on our site in which you have expressed interest. At your option, you may also provide demographic information (such as gender or age) about yourself, but it is not required.
              </p>
              
            </section>

            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold text-primary">
              INFORMATION COLLECTION, USE AND SHARING
              </h2>

              <p className="text-[#0d121f] text-[18px]">
              When you become a member with us, as part of the process, we collect the personal information you give us such as your name, address, telephone number and email address. We are the sole owners of the information collected on this site. We only have access to/collect information that you voluntarily give us via email or other direct contact from you. We will not sell or rent this information to anyone. We will not share your information with any third party outside of our organization, other than as necessary to fulfill your request, e.g. to ship an order.
              </p>

              <p className="text-[#0d121f] text-[18px]">
              Unless you ask us not to, we may contact you via email in the future to tell you about specials, new products or services, or changes to this privacy policy.
              </p>

            </section>

            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold text-primary">
              YOUR ACCESS TO AND CONTROL OVER INFORMATION
              </h2>

              <p className="text-[#0d121f] text-[18px]">You may opt out of any future contacts from us at any time. You can do the following at any time by contacting us via the email address or phone number given on our website:</p>

              
              <p className="text-[#0d121f] text-[18px]">
                <ul className="space-y-[30px] list-disc list-inside">
                    <li>What personally identifiable information is collected from you through the website, how it is used and with whom it may be shared.</li>
                    <li>What choices are available to you regarding the use of your data..</li>
                    <li>The security procedures in place to protect the misuse of your information.</li>
                    <li>How you can correct any inaccuracies in the information.</li>
                </ul>
              </p>
              
             
            </section>

            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold mb-2 text-primary">
              SECURITY AND THIRD-PARTY SERVICES
              </h2>
              <p className="text-[#0d121f] text-[18px]">We use third-party e-commerce platforms that allow us to sell our services to you. We recommend that you read their privacy policies so you can understand the manner in which your personal information will be handled.</p>
              <p className="text-[#0d121f] text-[18px]">
              Wherever sensitive information is collected, (such as credit card data), that information is encrypted and transmitted in a secure way. You can verify this by looking for a lock icon in the address bar and looking for &quot;https&quot; at the beginning of the address of the Web page.
              </p>
              <p className="text-[#0d121f] text-[18px]">
              While we use encryption to protect sensitive information transmitted online, we also protect your information offline. The computers/servers in which we store personally identifiable information are kept in a secure environment.
              </p>
              <p className="text-[#0d121f] text-[18px]">
              If you feel that we are not abiding by this privacy policy, you should contact us immediately via telephone at 778-318-5350 or via email, info@buildmapper.com
              </p>
    
            </section>

            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold text-primary">
              COOKIES
              </h2>

              <p className="text-[#0d121f] text-[18px]">
              We use "cookies" on this site. A cookie is a piece of data stored on a site visitor's hard drive to help us improve your access to our site and identify repeat visitors to our site. For instance, when we use a cookie to identify you, you would not have to Login a password more than once, thereby saving time while on our site. Cookies can also enable us to track and target the interests of our users to enhance the experience on our site. Usage of a cookie is in no way linked to any personally identifiable information on our site.
              </p>

              

            </section>

            <section className="space-y-[30px]">
              <h2 className="text-2xl font-semibold text-primary">
              LINKS
              </h2>

              <p className="text-[#0d121f] text-[18px]">
              This website contains links to other sites. Please be aware that we are not responsible for the content or privacy practices of such other sites. We encourage our users to be aware when they leave our site and to read the privacy statements of any other site that collects personally identifiable information.
              </p>

            

            </section>


 




          </div>
        </div>
      </div>
      <FooterByAnima />
    </>
  );
};

export default PrivacyPolicy;
